import React from 'react';
import { RawHTML } from '../raw-html';
import './dx-tooltip-question.scss';
export var TOOLTIP_TYPES;
(function (TOOLTIP_TYPES) {
    TOOLTIP_TYPES["RIGHT"] = "right";
})(TOOLTIP_TYPES || (TOOLTIP_TYPES = {}));
const CONTAINER_CLASSES = {
    [TOOLTIP_TYPES.RIGHT]: 'dx-tooltip__container-right',
};
const getContainerClasses = (type) => {
    const common = 'dx-tooltip__container dx-tooltip__container-gray';
    return [common, CONTAINER_CLASSES[type]].join(' ');
};
export const DxTooltipQuestion = ({ tooltipText, type }) => {
    return (<div className={getContainerClasses(type)}>
      <span className="dx-tooltip__icon-question"/>
      <div className="dx-tooltip">
        <div className="dx-tooltip__inner" data-test-id="tooltip-inner">
        <RawHTML>{tooltipText}</RawHTML>
        </div>
      </div>
    </div>);
};
